



































































import Vue, { PropType } from 'vue';
import { formatDateString } from '@/helpers/formatters';
import {
  isRgValid,
  isDateStringValid,
  isDateLessOrEqualToday,
  isDateMoreOrEqualBirthdate,
  isIssueStateValid,
} from '@/helpers/validators';
import { AutoCompleteInput, OutlinedTextInput, OutlinedSelect } from '@/components/ds';
import { AutocompleteOption, parseToAutocompleteOption } from '@/helpers/autocomplete';

export interface IdentificationDocumentFormEvent {
  rg: string;
  issueDate: string;
  issuer: string;
  issueState: string;
  motherName: string;
  fatherName: string;
}

export default Vue.extend({
  components: { AutoCompleteInput, OutlinedTextInput, OutlinedSelect },
  props: {
    currentRg: {
      type: String,
      default: '',
    },
    currentIssueDate: {
      type: String,
      default: '',
    },
    currentIssuer: {
      type: String,
      default: '',
    },
    currentIssueState: {
      type: String,
      default: '',
    },
    currentMotherName: {
      type: String,
      default: '',
    },
    currentFatherName: {
      type: String,
      default: '',
    },
    issueStateOptions: {
      type: Array as PropType<string[]>,
      default: [],
    },
    issuerOptions: {
      type: Array as PropType<AutocompleteOption[]>,
      default: [],
    },
  },
  data() {
    return {
      form: {
        rg: this.currentRg,
        issueDate: this.currentIssueDate,
        issuer: this.currentIssuer,
        issueState: this.currentIssueState,
        motherName: this.currentMotherName,
        fatherName: this.currentFatherName,
      },
      masks: {
        date: formatDateString,
      },
      errors: {
        rg: false,
        issueDate: false,
        issueState: false,
      },
    };
  },
  computed: {
    selectedIssuer(): AutocompleteOption {
      return parseToAutocompleteOption(this.form.issuer);
    },
  },
  methods: {
    inputHandler() {
      this.errors.rg = !!this.form.rg && !isRgValid(this.form.rg);

      this.errors.issueDate =
        (!!this.form.issueDate && !isDateStringValid(this.form.issueDate)) ||
        !isDateLessOrEqualToday(this.form.issueDate) ||
        !isDateMoreOrEqualBirthdate(
          this.form.issueDate,
          this.$store.getters.personalData?.birthDate,
        );

      // o guard `!!` segue o padrão do arquivo: não pintar de vermelho antes de o lead
      // mexer no campo. Já o hasErrors valida sem guard, para o botão Avançar continuar
      // bloqueado enquanto a UF estiver vazia — que é justamente o estado em que o
      // tradutor deixava o campo.
      this.errors.issueState =
        !!this.form.issueState && !isIssueStateValid(this.form.issueState, this.issueStateOptions);

      const hasErrors =
        this.errors.rg ||
        this.errors.issueDate ||
        !isIssueStateValid(this.form.issueState, this.issueStateOptions);

      const event: IdentificationDocumentFormEvent = { ...this.form };

      this.$emit('input', event, hasErrors);
    },
    selectHandlerIssuer(option: AutocompleteOption) {
      this.form.issuer = option.value;
      this.inputHandler();
    },
  },
});
